<template>
  <div v-if="pedido">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-card>
        <v-card-title class="d-flex flex-column align-start">
          <span class="subtitle-1"
            >{{ pedido.data_inicio | date2br }} -
            {{ pedido.data_fim | date2br }}</span
          >
          <span class="subtitle-1">{{ pedido.descricao }}</span>
          <span class="text-caption"
            >Quantidade atual: {{ pedido.quantidade }}</span
          >
          <span class="text-caption">Pedido: {{ pedido.public_id }}</span>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          <v-row>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                name="adicionar_quantidade"
              >
                <v-text-field
                  type="number"
                  label="Adicionar Quantidade (Ton)"
                  v-model="adicionar_quantidade"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black darken-1" text @click="$emit('close')"
            >Fechar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            :disabled="invalid"
            @click="adicionar()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </div>
</template>

<script>
import { toBrazilianDateTime } from '@/mixins/convertion'
import { mapActions } from 'vuex'

export default {
  name: 'Adicionar',
  props: {
    pedido: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      adicionar_quantidade: 0,
    }
  },
  filters: {
    toBrazilianDateTime,
    date2br(data) {
      if (!data) return '-'
      const data_splitted = data.split('-')
      return `${data_splitted[2]}/${data_splitted[1]}/${data_splitted[0]}`
    },
  },
  methods: {
    ...mapActions('patio', ['adicionarQuantidadePedido']),
    ...mapActions('template', ['successMessage', 'errorMessage']),
    async adicionar() {
      try {
        const data = await this.adicionarQuantidadePedido({
          pedido: this.pedido,
          payload: {
            adicionar_quantidade: this.adicionar_quantidade,
          },
        })
        this.successMessage('Quantidade adicionada com sucesso')
        this.$emit('close')
        this.$emit('save', data)
      } catch (error) {
        if (error.response) {
          this.errorMessage(error.response.data)
          return
        }
        if (error.message) {
          this.errorMessage(error.message)
          return
        }
        this.errorMessage(error)
      }
    },
  },
}
</script>
<style></style>
